import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FaDownload } from "react-icons/fa";
import { getApiCall } from "../../service/httpCall";
import Loader from "../../components/partials/components/loader";
import { toast } from "react-toastify";
import { FilterMatchMode } from "primereact/api";
import { API_DASHBOARD_TODAY_RUNNING_CAMPAIGN_SUMMARY_STATS } from "../../service/url";

import { USER_ROLES } from "../../utilities/constant";
import { Storage } from "../../utilities/setting";

const TodayRunningCampaigns = () => {
  const dt = useRef(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tableFilters, setTableFilters] = useState({
    global:       { value: null, matchMode: FilterMatchMode.CONTAINS },
    campaignName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    campaignId:   { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);

  useEffect(() => {
    async function checkUserRole() {
      const rawUser = Storage.getItem("user");
      if (!rawUser) { console.error("User not found in Storage"); return null; }
      let user;
      try { user = JSON.parse(rawUser); } catch (e) { console.error("Invalid JSON", e); return null; }
      if (user.role) setLoggedInUserRole(user.role);
    }
    checkUserRole();
  }, []);

  useEffect(() => {
    if (!loggedInUserRole) return;
    if (loggedInUserRole == USER_ROLES.CALL_CENTRE_AGENT) return;
    fetchData();
  }, [loggedInUserRole]);

  const fetchData = () => {
    setLoading(true);
    getApiCall(API_DASHBOARD_TODAY_RUNNING_CAMPAIGN_SUMMARY_STATS)
      .then((resp) => {
        const formatted = (resp.data || resp).map((item) => ({
          ...item,
          campaignId:   item.campaignId?.toString(),
          campaignName: item.campaignName?.toString(),
        }));
        setData(formatted);
      })
      .catch((err) => toast.error(err?.message || "Failed to fetch data"))
      .finally(() => setLoading(false));
  };

  const clearFilters = () => {
    setTableFilters({
      global:       { value: null, matchMode: FilterMatchMode.CONTAINS },
      campaignName: { value: null, matchMode: FilterMatchMode.CONTAINS },
      campaignId:   { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    setGlobalFilterValue("");
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setGlobalFilterValue(value);
    setTableFilters((prev) => ({ ...prev, global: { value, matchMode: FilterMatchMode.CONTAINS } }));
  };

  const exportCSV = () => {
    const headers = ["Campaign ID","Campaign Name","Start Time","Total Numbers","Calls Dialed","Pending Calls","Connected Calls","DTMF Count"];
    const rows = data.map((row) => [row.campaignId,row.campaignName,row.startTime,row.totalNumbers,row.callsDialed,row.pendingCalls,row.connectedCalls,row.dtmfCount]);
    const link = document.createElement("a");
    link.href = encodeURI("data:text/csv;charset=utf-8," + [headers, ...rows].map((e) => e.join(",")).join("\n"));
    link.download = "today-running-campaigns.csv";
    link.click();
  };

  if (loading) return <Loader />;

  return (
    <div className="dash-section-card" style={{ marginBottom: 28 }}>
      <div className="dash-section-header">
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span>Today's Running Campaigns</span>
          {data.length > 0 && (
            <span className="dash-count-badge">{data.length}</span>
          )}
        </div>
        {data.length > 0 && (
          <button className="dash-action-btn dash-action-btn--export" onClick={exportCSV} title="Export CSV">
            <FaDownload size={11} /> Export
          </button>
        )}
      </div>

      <div className="dash-table-toolbar">
        <div className="dash-search-wrap">
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Search by campaign name or ID…"
            className="dash-search-input"
          />
        </div>
      </div>

      <div style={{ overflowX: "auto" }}>
        <DataTable
          ref={dt}
          value={data}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          filters={tableFilters}
          onFilter={(e) => setTableFilters(e.filters)}
          globalFilterFields={["campaignName", "campaignId"]}
          emptyMessage="No running campaigns found for today"
          responsiveLayout="scroll"
          className="dash-datatable"
        >
          <Column field="campaignId"     header="Campaign ID"     sortable filter filterPlaceholder="Search ID" />
          <Column field="campaignName"   header="Campaign Name"   sortable filter filterPlaceholder="Search Name" />
          <Column field="startTime"      header="Start Time"      sortable />
          <Column field="totalNumbers"   header="Total Numbers"   sortable />
          <Column field="callsDialed"    header="Calls Dialed"    sortable />
          <Column field="pendingCalls"   header="Pending Calls"   sortable />
          <Column field="connectedCalls" header="Connected Calls" sortable />
          <Column field="dtmfCount"      header="DTMF Count"      sortable />
        </DataTable>
      </div>
    </div>
  );
};

export default TodayRunningCampaigns;
